import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Spin } from 'antd';
import SearchForm from './components/SearchForm'
import SearchResult from './components/SearchResult'
@inject('userManagementStore')
@observer
class UserManagement extends Component {
  state = {
  }
  componentDidMount() {
  }
  render() {
    const { userManagementStore,location } = this.props
    const { isFetching } = userManagementStore
    return (
      <Spin spinning={isFetching}>
        <div className="container">
          <SearchForm  location={location}/>
          <SearchResult />
        </div>
      </Spin>
    );
  }
}
export default UserManagement;
